import { anonymousRequest } from './auth';

const placeContactRequest = async (form) => {
  return anonymousRequest.post('/contact/', form)
  .then((response) => Promise.resolve(response.data))
  .catch((error) => Promise.reject(error));
}

export { placeContactRequest };